import { withValues } from '@/form/ActionForm/useActionFormValues/useActionFormValues'
import type { DonationFormValues } from '@/donationForm/types'
const useDonationFormValues = withValues<DonationFormValues>()
export default useDonationFormValues
